export default __webpack_public_path__ + "static/media/L_LVT.cf3519e8.jpg";